import { render } from "./crypt-transfer-confrim.vue?vue&type=template&id=b3042a1a&ts=true"
import script from "./crypt-transfer-confrim.vue?vue&type=script&lang=ts"
export * from "./crypt-transfer-confrim.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__